import { marginPropertyNames } from "./filter-styled-system-margin-props";
import { paddingPropertyNames } from "./filter-styled-system-padding-props";
const filterOutStyledSystemSpacingProps = props => Object.fromEntries(Object.entries(props).filter(([key]) => ![...marginPropertyNames, ...paddingPropertyNames].includes(key)));
export default filterOutStyledSystemSpacingProps;